
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import {CashoutMoney} from "../../../../dev/actions/terminal";
import { UIMixin } from "../../../mixins/uiMixin";
import PropTypes from "prop-types";
import { createSelector } from "reselect";

class DmsCashout extends Component {
    constructor (props) {
        super(props);
        this.state = {
            Name: '',
            Surname: '',
            CNP: ''
        };
        this.cashOut = this.cashOut.bind(this);
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    cashOut () {
        return () => {
            this.props.closePopup()();
            this.props.dispatch(CashoutMoney(null));
        };
    }
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn
        ],
        (isAdminLoggedIn) => {
            return {isAdminLoggedIn};
        }
    );
};

DmsCashout.propTypes = {
    closePopup: PropTypes.func
};

export default connect(mapStateToProps)(UIMixin({Component: DmsCashout}));